import React, { useRef, useState } from 'react';
import styles from './DatePickerCustom.module.scss';
import cn from 'classnames';
import { DatePicker, Tooltip } from 'antd';
import { enumTypePicker } from './constants';
import moment from 'moment';
import { parseDateWithoutSeparators } from './utils';
import DateRangePickerFooter from '../DateRangePickerFooter/DateRangePickerFooter';

const { MonthPicker, RangePicker, WeekPicker } = DatePicker;

const isDaySame = (start, end) => moment(start).isSame(end, 'day');

const DatePickerCustom = ({
  size = 'default',
  placeholder = 'DD.MM.YYYY',
  typePicker = enumTypePicker.DATE,
  format = 'DD.MM.YYYY',
  value,
  onChange,
  className,
  style,
  title = '',
  ...rest
}) => {
  const containerRef = useRef(null);

  const [isRangePickerOpen, setIsRangePickerOpen] = useState(false);

  const handleBlur = (event) => {
    let rawValue = '';

    if (event?.target?.value !== undefined) {
      rawValue = event.target.value;
    }

    if (!rawValue) {
      const input = containerRef.current?.querySelector('input');
      rawValue = input?.value || '';
    }

    if (!rawValue) return;

    const isValidWithSeparators = moment(rawValue, format, true).isValid();
    if (isValidWithSeparators) return;

    if (/^\d{8}$/.test(rawValue)) {
      const parsed = parseDateWithoutSeparators(rawValue, format);
      if (parsed && onChange) {
        onChange(parsed.date, parsed.string);
      }
    }
  };

  const isFastPeriodActive = (dates) => {
    if (
      typePicker !== enumTypePicker.RANGE ||
      !value ||
      !Array.isArray(value)
    ) {
      return false;
    }

    const [from, to] = dates.range;
    const [fromDate, toDate] = value;

    if (!fromDate || !toDate || !from || !to) {
      return false;
    }

    return isDaySame(fromDate, from) && isDaySame(toDate, to);
  };

  const propsComponent = {
    size,
    format,
    placeholder,
    value,
    onChange,
    className: cn(className, styles.root),
    style,
    onBlur: handleBlur,
    ...rest,
  };

  const getPicker = () => {
    switch (typePicker) {
      case enumTypePicker.DATE:
        return <DatePicker {...propsComponent} />;
      case enumTypePicker.RANGE:
        return (
          <RangePicker
            {...propsComponent}
            open={isRangePickerOpen}
            onOpenChange={(status) => setIsRangePickerOpen(status)}
            renderExtraFooter={() => (
              <DateRangePickerFooter
                rootClassName={styles.footer}
                isActiveFn={isFastPeriodActive}
                onRangeClick={(dates) => {
                  onChange(dates.range);
                  setIsRangePickerOpen(false);
                }}
              />
            )}
          />
        );
      case enumTypePicker.MONTH:
        return <MonthPicker {...propsComponent} />;
      case enumTypePicker.WEEK:
        return <WeekPicker {...propsComponent} />;
      default:
        return <DatePicker {...propsComponent} />;
    }
  };

  return (
    <div ref={containerRef}>
      <Tooltip title={title}>{getPicker()}</Tooltip>
    </div>
  );
};

export default DatePickerCustom;
